import React from 'react'
import { Link } from 'react-router-dom'
// Components
import LinksMap from '../components/LinksMap'
import PageTransition from '../components/PageTransition'
// CSS
import '../assets/css/checkout.css'
import '../assets/css/form.css'
import { keyboard } from '@testing-library/user-event/dist/keyboard'
// Images
import PaymentMethodBanner from '../assets/images/payment-methods-small.jpg'

export default function Checkout() {
  return (
    <div className='checkout_page'>
      <PageTransition />
      <LinksMap linksArr={[{name: 'Home', path:'/', active: false}, {name: 'Cart', path:'/cart', active: false}, {name: 'Checkout', path: '/checkout', active: true}]} pageName="Checkout" />

      <form className='container wrapper checkout_form default'>
        <div className='billing_details'>
          <div className='header'>
            <div lclassName='title'>Billing details</div> 
          </div>
          <div className='content'>
            <div className='billing_form'>
              <div className='inputs'>
                <div className='input_group'>
                  <div className='input_container'>
                    <label htmlFor='first_name'>First Name <span>*</span></label>
                    <input type='text' id='first_name' required />
                  </div>
                  <div className='input_container'>
                    <label htmlFor='last_name'>Last Name <span>*</span></label>
                    <input type='text' id='last_name' required />
                  </div>
                </div>

                <div className='input_container'>
                  <label htmlFor='company_name'>Company name (Optional)</label>
                  <input type='text' id='company_name' />
                </div>

                <div className='input_container'>
                  <label htmlFor='country_region'>Country/Region <span>*</span></label>
                  <select id='country_region' required>
                    <option value='0'>Select a country</option>
                    <option value='1'>United States</option>
                    <option value='2'>Canada</option>
                  </select>
                </div>

                <div className='input_container'>
                  <label htmlFor='street_adress'>Street Adress <span>*</span></label>
                  <input type='text' id='street_adress' required />
                </div>

                <div className='input_container'>
                  <label htmlFor='city'>City <span>*</span></label>
                  <select id='city' required>
                    <option value='0'>Select a city</option>
                    <option value='1'>New York</option>
                    <option value='2'>Los Angeles</option>
                  </select>
                </div>

                <div className='input_container'>
                  <label htmlFor='state'>State <span>*</span></label>
                  <select id='state' required>
                    <option value='0'>Select a state</option>
                    <option value='1'>New York</option>
                    <option value='2'>California</option>
                  </select>
                </div>

                <div className='input_container'>
                  <label htmlFor='zip_code'>Zip Code <span>*</span></label>
                  <input type='text' id='zip_code' required />
                </div>

                <div className='input_container'>
                  <label htmlFor='phone_number'>Phone Number <span>*</span></label>
                  <input type='text' id='phone_number' required />
                </div>

                <div className='input_container'>
                  <label htmlFor='email'>Email Address <span>*</span></label>
                  <input type='email' id='email' required />
                </div>

                <div className='input_container'>
                  <label htmlFor='order_notes'>Order Notes (Optional)</label>
                  <textarea id='order_notes'></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className='payment_details'>
          <div className='payment_details_header'>
            <div className='title'>Your Order</div>
          </div>
          <div className='products section'>
            <div className='header'>
              <div className='title'>Product</div>
            </div>
            <div className='content'>
              <div className='card'>
                <div className='title'>Battery charger <span className='fas fa-times'></span> <span>03</span></div>
                <div className='price'>$10.00</div>
              </div>
              <div className='subtotal card'>
                <div className='title'>Subtotal</div>
                <div className='price'>$10.00</div>
              </div>
            </div>
          </div>

          <div className='shipping_option section'>
            <div className='header'>
              <div className='title'>Shipping</div>
            </div>
            <div className='content'>
              <div className='input_container radio'>
                <input type='radio' name='shipping_option' id='shipping_option_1' required />
                <label htmlFor='shipping_option_1'> Free Shipping</label>
              </div>
              <div className='input_container radio'>
                <input type='radio' name='shipping_option' id='shipping_option_2' required />
                <label htmlFor='shipping_option_2'>Home Delivery <span>$1.00</span></label>
              </div>
              <div className='input_container radio'>
                <input type='radio' name='shipping_option' id='shipping_option_3' required />
                <label htmlFor='shipping_option_3'>Local Pickup</label>
              </div>
            </div>
          </div>

          <div className='total_price section'>
            <div className='content'>
              <div className='title'>Total</div>
              <div className='price'>$11.00</div>
            </div>
          </div>

          <div className='payment_methods section'>
            <div className='header'>
              <div className='title'>Payment method</div>
            </div>

            <div className='content'>
              <div className='input_container radio'>
                <input type='radio' name='payment_method' id='payment_method_1' required />
                <label htmlFor='payment_method_1'>Cash On Delivery</label>
              </div>
              <div className='input_container radio'>
                <input type='radio' name='payment_method' id='payment_method_2' required />
                <label htmlFor='payment_method_2'>Paypal <img src={PaymentMethodBanner} /></label>
              </div>
            </div>
          </div>

          <div className='submit_button section'>
            <button type='submit'>Place Order</button>
          </div>
        </div>
      </form>
    </div>
  )
}
